import * as React from 'react'

import { Notice, Link } from '@buffer-mono/popcorn'

import { useIsBetaEnabled } from '~publish/contexts/AccountContext'
import { useDismissableBanner } from '~publish/hooks/useDismissableBanner'

import { ScheduleOptionItem } from './ScheduleOptionItem'
import type { ScheduleOption, ScheduleSelectorState } from './types'

import styles from './ScheduleSelector.module.css'

type ScheduleSelectorDropDrownOptionsProps = {
  onSelect: (option: ScheduleOption, event: Event) => void
  currentSelection: ScheduleSelectorState
  options: ScheduleOption[]
  defaultOption?: ScheduleOption
}
export const ScheduleSelectorOptions: React.FC<
  ScheduleSelectorDropDrownOptionsProps
> = ({ onSelect, currentSelection, options, defaultOption }) => {
  const [hoveredOption, setHoveredOption] =
    React.useState<ScheduleOption | null>(null)

  const isBeta = useIsBetaEnabled()
  const banner = useDismissableBanner(
    'change-default-schedule-option-in-settings-1',
  )

  return (
    <>
      {banner.isActive && (
        <Notice
          variant="info"
          icon={false}
          className={styles.defaultSettingsNotice}
          onDismiss={banner.dismiss}
        >
          <Notice.Text>
            Change the default in your{' '}
            <Link href="/settings/preferences" external>
              account settings
            </Link>
            .
          </Notice.Text>
          {isBeta && (
            <Notice.Text>
              This is a new{' '}
              <Link href="/settings/beta" external>
                beta
              </Link>{' '}
              feature.
            </Notice.Text>
          )}
        </Notice>
      )}
      {options.map((option) => {
        const isSelected = option === currentSelection.option
        const isDefault = option === defaultOption
        const isHighlighted = hoveredOption
          ? hoveredOption === option
          : isSelected

        return (
          <ScheduleOptionItem
            key={option}
            option={option}
            isSelected={isSelected}
            isDefault={isDefault}
            onSelectOption={onSelect}
            onMouseEnter={(): void => setHoveredOption(option)}
            isHighlighted={isHighlighted}
          />
        )
      })}
    </>
  )
}
